module.exports = __webpack_public_path__ + "static/logo-0218e81e085ea3511e678119e40e350f.png";